import { Injectable } from "@angular/core";
import { Practitioner } from "src/app/ui/models/domains/pbm/practitioner-management/practitioner";
import { AbstractParser } from "../../parser";
import { parsePractitioner } from "./practitioner-management-parse-function";

@Injectable()
export class SearchPractitionerByKeyParser extends AbstractParser<Practitioner> {
  parse(payload: any) {
    return parsePractitioner(payload);
  }
}
